import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clientes from "@/pages/Clientes";
import ClientDetail from "@/pages/ClientDetail";
import ClientPortal from "@/pages/ClientPortal";
import Proyectos from "@/pages/Proyectos";
import ProjectDetail from "@/pages/ProjectDetail";
import Agenda from "@/pages/Agenda";
import Pagos from "@/pages/Pagos";
import Equipo from "@/pages/Equipo";
import Reportes from "@/pages/Reportes";
import Documentos from "@/pages/Documentos";
import Configuracion from "@/pages/Configuracion";
import PublicDoc from "@/pages/PublicDoc";
import "@/App.css";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0D12] flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-[#F97316] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/portal/:token" element={<ClientPortal />} />
      <Route path="/doc/:token" element={<PublicDoc />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/clientes" element={<Protected><Clientes /></Protected>} />
      <Route path="/clientes/:id" element={<Protected><ClientDetail /></Protected>} />
      <Route path="/proyectos" element={<Protected><Proyectos /></Protected>} />
      <Route path="/proyectos/:id" element={<Protected><ProjectDetail /></Protected>} />
      <Route path="/agenda" element={<Protected><Agenda /></Protected>} />
      <Route path="/pagos" element={<Protected><Pagos /></Protected>} />
      <Route path="/equipo" element={<Protected><Equipo /></Protected>} />
      <Route path="/reportes" element={<Protected><Reportes /></Protected>} />
      <Route path="/documentos" element={<Protected><Documentos /></Protected>} />
      <Route path="/configuracion" element={<Protected><Configuracion /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="dark">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
